// extracted by mini-css-extract-plugin
export default {"header":"cf8gfthre","stars":"cmz9z82ce","buttonContainer":"cd43uxv92"};